/*
 *  Wishlist Tools
 *    Tools to update elements based on wishlist events.
 * 
 * 
 */

const WISHLIST_COUNT = '[data-wishlist-count]';
const WISHLIST_COUNT_MOBILE = '[data-wishlist-count-mobile]';
const S_THUMBNAIL_BUTTON = '[data-product-template-wishlist]';

const A_WISHLIST_EPI = 'data-wishlist-epi';
const A_WISHLIST_EMPI = 'data-wishlist-empi';
const A_WISHLIST_IU = 'data-wishlist-iu';
const A_WISHLIST_PR = 'data-wishlist-pr';
const A_WISHLIST_STK = 'data-wishlist-stk';
const A_WISHLIST_DU = 'data-wishlist-du';
const A_WISHLIST_DT = 'data-wishlist-dt';

//Find all visible wishlist buttons on page and iterate
export const initialiseWishlist = () => {
  let buttons = $(document).find(S_THUMBNAIL_BUTTON);
  let retries = 5;

  if (buttons.length === 0) {
    let timeout = setInterval(function() {
      buttons = $(document).find(S_THUMBNAIL_BUTTON);
      
      if (buttons.length || retries === 0) {
        // buttons.each(function(i, e) {
        //   let data = getWishlistData($(e));
        //   updateWishlistButtonState(data, e);
        // });

        updateWishlistButtonState();
        clearInterval(timeout);
      }
      retries--;
    }, 200);
  } else {
    updateWishlistButtonState();
    // buttons.each(function(i, e) {
    //   let data = getWishlistData($(e));
    //   updateWishlistButtonState(data, e);
    // });
  }
}

export const updateWishlistButtonState = () => {
  if(!window.SwymCallbacks) { window.SwymCallbacks = []; }
  updateHeaderWishlist();
  // $(document).off('click', S_THUMBNAIL_BUTTON);

  window.SwymCallbacks.push(() => {
    _swat.fetchWrtEventTypeET((products) => {

      $(document).find(S_THUMBNAIL_BUTTON).each(function(i, e) {
        let data = getWishlistData($(e));

        var isInWishlist = products.find(function(p) {
          return p.empi == data.empi && p.epi == data.epi;
        });
        if (isInWishlist) {
          e.classList.add('is-saved');
        }
      });

      $(document).on('click', S_THUMBNAIL_BUTTON , function(e) {
        e.preventDefault();
        e.stopPropagation();

        let saved = e.currentTarget.classList.contains('is-saved');
        let el = e.currentTarget;
        let data = getWishlistData($(el));

        if (!saved) {
          if (data) {
            // remove params from url to stop wishlist complaining
            let tempDu = data.du;
            if (tempDu.indexOf('?') !== -1 ) {
              data.du = tempDu.split('?')[0];
            }
            data.et = 4;	// et 4 stands for wishlist event type
            _swat.addToWishList(data, function(e) {
              el.classList.add('is-saved');
              updateHeaderWishlist();
            });
          }
        } else {
          if (data) {
            data.et = 4;	// et 4 stands for wishlist event type
            _swat.removeFromWishList(data, function(e) {
              el.classList.remove('is-saved');
              updateHeaderWishlist();
            });
          }
        }

      });
    });
  });
}

export const getWishlistData = (el) => {
  let data = {
    "epi": parseInt(el.attr(A_WISHLIST_EPI)),
    "empi": parseInt(el.attr(A_WISHLIST_EMPI)),
    "iu": el.attr(A_WISHLIST_IU),
    "pr": parseInt(el.attr(A_WISHLIST_PR)),
    "stk": parseInt(el.attr(A_WISHLIST_STK)),
    "du": el.attr(A_WISHLIST_DU),
    "dt": el.attr(A_WISHLIST_DT)
  };

  return data;
}

export const updateHeaderWishlist = () => {
  let el = $(WISHLIST_COUNT);
  let elMobile = $(WISHLIST_COUNT_MOBILE);

  if(!el.length) return;
  let count = "";

  window.SwymCallbacks.push(() => {
    _swat.fetchWrtEventTypeET((products) => {
      count = products.length;
      el.html(`${count}`)
      elMobile.html(`&nbsp;(${count})`)
    });
  });
}